import { EVENT_STATUS } from "../../constants/event";

export function getActiveLiveContent() {
    return window.__UpshowState && window.__UpshowState.activeLiveContent;
}

// Splits events into three (intentionally overlapping) buckets:
//   - live: LIVE or COMING events (actively on-air or about to start).
//   - upcoming: all SCHEDULED events (future, regardless of subscription).
//   - scheduled: subset of upcoming where the device is subscribed — shown in a separate EPG section.
export function categorizeEvents(events) {
    const live = [], upcoming = [], scheduled = [];
    events.forEach((event) => {
        if (event.status === EVENT_STATUS.LIVE || event.status === EVENT_STATUS.COMING) live.push(event);
        if (event.status === EVENT_STATUS.SCHEDULED) upcoming.push(event);
        if (event.status === EVENT_STATUS.SCHEDULED && event.isDeviceSubscribed) scheduled.push(event);
    });
    return { live, upcoming, scheduled };
}
